
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "My favourite Mac apps";
export const tags = ["Other"];
export const image = "/blog-images/yabai.jpg";
export const description = "A personal list of useful Mac apps for productivity, development, and maintenance.";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    h2: "h2",
    h3: "h3",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "macOS is a nice operating system, but is very lacking in good functionality out of the box. Thankfully, lots of solutions exist for minor nitpicks and issues."
    }), "\n", _jsx(_components.p, {
      children: "All apps are free unless indicated otherwise, and I am not affiliated with any of the developers.\nExpect this list to be updated over time."
    }), "\n", _jsx(_components.h2, {
      children: "Productivity"
    }), "\n", _jsx(_components.h3, {
      children: "Raycast"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/raycast.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.raycast.com/",
        children: "Raycast"
      }), " is a Spotlight Search replacement for macOS."]
    }), "\n", _jsx(_components.h3, {
      children: "yabai"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/yabai.jpg",
        alt: "Screenshot of example layout"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://github.com/koekeishiya/yabai",
        children: "yabai"
      }), " is a tiling window manager for macOS, similar to Hyprland, sway, or i3 on Linux."]
    }), "\n", _jsx(_components.h3, {
      children: "Bartender 5"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/bartender.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.macbartender.com/",
        children: "Bartender"
      }), " ($30, but free trial can be reset by clearing app data) is an app that can hide excess menu bar items until you expand them. As mentioned earlier, if you clear the app data (e.g. using AppCleaner), the free trial can be extended by another 30 days."]
    }), "\n", _jsx(_components.h2, {
      children: "Development"
    }), "\n", _jsx(_components.h3, {
      children: "Warp"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/warp.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://warp.dev",
        children: "Warp"
      }), " is an excellent terminal application for macOS, Linux and Windows that has a modern user interface. They also gave me a free shirt once."]
    }), "\n", _jsx(_components.h3, {
      children: "Hex Fiend"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/hexfiend.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://hexfiend.com/",
        children: "Hex Fiend"
      }), " is a fast, native hex editor for macOS."]
    }), "\n", _jsx(_components.h2, {
      children: "Maintenance"
    }), "\n", _jsx(_components.h3, {
      children: "OnyX"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/onyx.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.titanium-software.fr/en/onyx.html",
        children: "OnyX"
      }), " is a comprehensive utility for maintaining your Mac. It lets you perform maintainance tasks such as rebuilding indexes and clearing system caches, in addition to other useful features such as various inaccessible system settings."]
    }), "\n", _jsx(_components.h3, {
      children: "OmniDiskSweeper"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/omnidisksweeper.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://www.omnigroup.com/more",
        children: "OmniDiskSweeper"
      }), " shows you a map of the files on any storage device sorted by size, and lets you easily free up space."]
    }), "\n", _jsx(_components.h3, {
      children: "AppCleaner"
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/appcleaner.jpg",
        alt: "Screenshot"
      })
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://freemacsoft.net/appcleaner/",
        children: "AppCleaner"
      }), " lets you completely and thoroughly uninstall apps on macOS. It's pretty useful for clearing the data of apps that download a lot of miscellaneous files."]
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	